/**
 * Created by jacky on 10/7/16.
 * @flow
 * @providesModule Query
 */
import SockJS from "sockjs-client";

export type QueryObjType = {
    send(data: QueryCommandType): void;
    close: () => void;
}

export type QueryCommandType =
    { command: 'SignUp',
        data: {
            firstName: string;
            lastName: string;
            company?: string;
            email: string;
            password: string;
            product: string;
            coupon?: string;
            contentPool: string;
            contentId: string;
            signupPage: ?string;
            visitorSessionId: ?string;
        }
    }
    | { command: 'SignIn',
        data: {
            email: string;
            password: string;
            coupon?: string;
            contentPool: string;
            contentId: string;
        }
    }
    | { command: 'CreateContent',
        data: {
            sessionKey: string;
            workspaceId: string;
            contentPool: string;
            contentId: string;
        }
    }

export type StatusTypesType = 'Status';
export type EventStatusTypes = 'SignUpInitiated' |
    'SignInInitiated' |
    'SignedUp' |
    'SignedIn' |
    'SignUpFailed' |
    'SignInFailed' |
    'SelectWorkspace' |
    'CreatingContent' |
    'ContentCreated' |
    'ContentCreationFailed' |
    'GoToURL';

export type ProcessingStatusType = EventStatusTypes | 'dataQuery';

export type WorkspaceInfoType = {
    id: string;
    active: boolean;
    name: string;
    role: string;
}

export type SignupFailTypes = 'AlreadyCompleted' | 'BadInput' | 'GeneralError';
export type SigninFailTypes = 'UserNotFound' | 'NotConfirmed'| 'WrongPassword' | 'GeneralError';

export type EventType = {
        status: EventStatusTypes;
        data?: string | SignupFailTypes | SigninFailTypes;
        sessionKey?: string;
        userId?: string;
        workspaces?: Array<any>;
        url?: string;
    }
    | {
        status: 'SignUpInitiated'
    }
    | {
        status: 'SignedUp';
        data: string;
        sessionKey: string;
        userId: string;
    }
    | {
        status: 'SignUpFailed',
        data: SignupFailTypes
    }
    | {
        status: 'SelectWorkspace',
        workspaces: Array<any>,
        sessionKey: string
    }
    | {
        status: 'SignInInitiated'
    }
    | {
        status: 'SignedIn'
    }
    | {
        status: 'SignInFailed',
        data: SigninFailTypes
    }
    | {
        status: 'CreatingContent'
    }
    | {
        status: 'ContentCreated'
    }
    | {
        status: 'ContentCreationFailed'
    }
    | {
        status: 'GoToURL',
        sessionKey: string;
        url: string;
    }

export type queryResponse = {
    event: 'Status',
    data: EventType;
}


export function query(handler: (robj: EventType, q: QueryObjType) => void): Promise<QueryObjType> {
    return new Promise(rslv => {
        let socket = new SockJS(signupConfig.signupSocket);
        let robj: QueryObjType = {
            send: function (data: QueryCommandType): void {
                (socket: any).send(JSON.stringify(data));
            },
            close: () => {
                (socket: any).close();
                socket = null;
            }
        };

        socket.onopen = () => {
            rslv(robj);
        };

        socket.onmessage = (ev: MessageEvent) => {
            let d: queryResponse;
            try {
                d = JSON.parse(ev.data.toString());
            } catch (e) {
                handler(e, robj);
                (d: any).data = {};
            }
            handler((d: any).data, robj);
        };
    })
}



// WEBPACK FOOTER //
// ./src/lib/query.js